import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Components/Images/SENSETECH.png'

function Header() {
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const dropdownRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowMegaMenu(false);
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Initialize RD Navbar
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/assets/js/script.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Function to close the mega menu
  const handleLinkClick = () => {
    setShowMegaMenu(false);
     window.scrollTo(0, 0);
  };

  return (
    <div>
    <a 
      className="section section-banner d-none d-xl-block" 
      href="#"
      style={{
        backgroundImage: 'url(assets/images/banner/background-04-1920x60.jpg)',
        backgroundImage: '-webkit-image-set(url(assets/images/banner/background-04-1920x60.jpg) 1x, url(assets/images/banner/background-04-3840x120.jpg) 2x'
      }}
    >
      <img 
        src="assets/images/banner/foreground-04-1600x60.png" 
        srcSet="assets/images/banner/foreground-04-1600x60.png 1x, assets/images/banner/foreground-04-3200x120.png 2x" 
        alt="" 
        width="1600" 
        height="310"
      />
    </a>
        
      <header className="section page-header">
        <div className="rd-navbar-wrap rd-navbar-modern-wrap">
          <nav className="rd-navbar rd-navbar-modern" data-layout="rd-navbar-fixed">
            <div className="rd-navbar-main-outer">
              <div className="rd-navbar-main">
                {/* RD Navbar Panel */}
                <div className="rd-navbar-panel">
                  <button className="rd-navbar-toggle" data-rd-navbar-toggle=".rd-navbar-nav-wrap">
                    <span></span>
                  </button>
                  <div className="rd-navbar-brand">
                    <a className="brand" href="/">
                      <img src={Logo} alt="" width="200" height="40"/>
                    </a>
                    {/*assets/images/logo-default-196x47.png*/}
                  </div>
                </div>
                
                <div className="rd-navbar-main-element">
                  <div className="rd-navbar-nav-wrap">
                    {/* Search */}
                    <div className="rd-navbar-search">
                    <button className="rd-navbar-search-toggle" data-rd-navbar-toggle=".rd-navbar-search"><span></span></button>
                      <form className="rd-search" action="#">
                        <div className="form-wrap">
                          <label className="form-label" htmlFor="rd-navbar-search-form-input">Search...</label>
                          <input className="rd-navbar-search-form-input form-input" id="rd-navbar-search-form-input" type="text" name="search"/>
                          <button className="rd-search-form-submit fl-bigmug-line-search74" type="submit"></button>
                        </div>
                      </form>
                    </div>
                    
                    {/* Nav Items */}
                    <ul className="rd-navbar-nav">
                      <li className="rd-nav-item ">
                        <a className="rd-nav-link" style={{textDecoration:'none'}} href="/">Home</a>
                      </li>
                      
                      {/* Products with Mega Dropdown */}
                      <li className="rd-nav-item" ref={dropdownRef}>
                        <div 
                          className="rd-nav-link" 
                          onClick={() => setShowMegaMenu(!showMegaMenu)}
                          style={{ cursor: 'pointer', position: 'relative' }}
                        >
                          Products
                          <span style={{ 
                            display: 'inline-block',
                            marginLeft: '5px',
                            transition: 'transform 0.3s',
                            transform: showMegaMenu ? 'rotate(180deg)' : 'none'
                          }}>▼</span>
                        </div>
                        
                        {/* Mega Dropdown Content */}
                        <div className="rd-megamenu" 
  style={{
    display: showMegaMenu ? 'block' : 'none',
    position: 'absolute',
    left: 0,
    width: '900px',
    backgroundColor: '#fff',
    boxShadow: '0 6px 12px rgba(0,0,0,0.1)',
    zIndex: 9999,
    padding: '2rem'
  }}
>
  <div className="row" style={{ margin: 0 }}>
    <div className="col-md-7" style={{ padding: '0 15px' }}>
      <h3 style={{
        borderBottom: '3px solid #00663b',
        paddingBottom: '0.75rem',
        marginBottom: '1.25rem',
        fontWeight: 600,
        fontSize: '1.1rem',
        color: '#00663b'
      }}>Industrial Division</h3>
      <div className="row" style={{ margin: 0 }}>
        <div className="col-md-7" style={{ padding: '0 15px' }}>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            fontFamily:'sans-serif'
          }}>
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/continuous-inkjet-printer" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>Continuous Inkjet Printers (CIJ)</Link>
            </li>
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/thermal-inkjet-printer" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>Thermal Inkjet Printer (TIJ)</Link>
            </li>
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/laser-printer" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>Laser Printers</Link>
            </li>
            
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/thermal-transfer-printer" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>Thermal Transfer Overprint</Link>
            </li>
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/industrial-weighing-scales" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>Weighing Scales</Link>
            </li>
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/packaging-machines" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>Packaging Machines</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <div className="col-md-5">
      <h3 style={{
        borderBottom: '3px solid #01557a',
        paddingBottom: '0.75rem',
        marginBottom: '1.25rem',
        fontWeight: 600,
        fontSize: '1.1rem',
        color: '#01557a'
      }}>Retail Division</h3>
      <div className="row" style={{ margin: 0 }}>
        <div className="col-md-8" style={{ padding: '0 15px' }}>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            fontFamily:'sans-serif'
           
          }}>
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/eas-system" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>EAS system</Link>
            </li>
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/retail-scales" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>Retail Weighing Scales</Link>
            </li>
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/barcode-products" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>Barcode Products</Link>
            </li>
            <li style={{ marginBottom: '3rem' }}>
              <Link to="/electronic-shelf-label" onClick={handleLinkClick} style={{
                textDecoration: 'none',
                color: '#555',
                display: 'block'
              }}>Electronic Shelf Label</Link>
              
            </li>
            <li style={{marginBottom:'3rem'}}>
              <Link to='/mobilesecurity' onClick={handleLinkClick} style={{
                textDecoration:'none',
                color:"#555",
                display:'block'
              }}>Mobile Security</Link>
            </li>
            <li style={{ 
  marginBottom: '3rem', 
  position: 'relative',
  paddingRight: '15px'
}}>
  <div 
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      position: 'relative'
    }}
    onClick={(e) => {
      e.stopPropagation();
      const submenu = document.querySelector('.pos-submenu');
      const arrow = e.currentTarget.querySelector('.pos-arrow');
      
      if (submenu.style.display === 'block') {
        submenu.style.display = 'none';
        arrow.style.transform = 'rotate(0deg)';
      } else {
        submenu.style.display = 'block';
        arrow.style.transform = 'rotate(90deg)';
      }
    }}
  >
    <Link 
      to="#" 
      onClick={handleLinkClick} 
      style={{
        textDecoration: 'none',
        color: '#555',
        display: 'inline-block',
        fontWeight: '500',
        transition: 'all 0.3s',
        '&:hover': {
          color: '#01557a'
        }
      }}
    >
      POS Systems
    </Link>
    <span className="pos-arrow" style={{
      display: 'inline-block',
      marginLeft: '8px',
      transition: 'transform 0.3s',
      fontSize: '0.8em',
      color: '#01557a'
    }}>▶</span>
  </div>
  
  {/* POS Submenu */}
  <ul className="pos-submenu" style={{
    display: 'none',
    listStyle: 'none',
    paddingLeft: '20px',
    marginTop: '0.8rem',
    borderLeft: '2px solid rgba(1, 85, 122, 0.3)',
    transition: 'all 0.3s ease-out'
  }}>
    <li style={{ 
      marginBottom: '1.2rem',
      marginTop:'1.3rem',
      position: 'relative'
    }}>
      <Link 
        to="/sunmi-pos" 
        onClick={handleLinkClick} 
        style={{
          textDecoration: 'none',
          color: '#666',
          display: 'block',
          transition: 'all 0.3s',
          padding: '0.3rem 0.5rem',
          borderRadius: '3px',
          fontSize: '0.95em',
         
          '&:hover': {
            color: '#01557a',
            backgroundColor: 'rgba(1, 85, 122, 0.05)',
            paddingLeft: '15px'
          }
        }}
      >
        <span style={{
          display: 'inline-block',
          width: '6px',
          height: '6px',
          backgroundColor: 'white',
          borderRadius: '50%',
          marginRight: '10px',
          verticalAlign: 'middle'
        }}></span>
        SUNMI
      </Link>
    </li>
    <li style={{ 
      marginBottom: '1.2rem',
      position: 'relative'
    }}>
      <Link 
        to="/sunmi-pos" 
        onClick={handleLinkClick} 
        style={{
          textDecoration: 'none',
          color: '#666',
          display: 'block',
          transition: 'all 0.3s',
          padding: '0.3rem 0.5rem',
          borderRadius: '3px',
          fontSize: '0.95em',
          '&:hover': {
            color: '#01557a',
            backgroundColor: 'rgba(1, 85, 122, 0.05)',
            paddingLeft: '15px'
          }
        }}
      >
        <span style={{
          display: 'inline-block',
          width: '6px',
          height: '6px',
          backgroundColor: 'white',
          borderRadius: '50%',
          marginRight: '10px',
          verticalAlign: 'middle'
        }}></span>
        ZAR POS
      </Link>
    </li>
  </ul>
</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
                      </li>
                      
                      <li className="rd-nav-item">
                        <a className="rd-nav-link" style={{textDecoration:'none'}} href="/services">Services</a>
                      </li>
                      <li className="rd-nav-item">
                        <a className="rd-nav-link" style={{textDecoration:'none'}} href="/about-us">About Us</a>
                      </li>
                      <li className="rd-nav-item">
                        <a className="rd-nav-link" style={{textDecoration:'none'}} href="/contact-us">Contact Us</a>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Project hamburger */}
                  <div className="rd-navbar-project-hamburger" data-multitoggle=".rd-navbar-main" data-multitoggle-blur=".rd-navbar-wrap" data-multitoggle-isolate>
                    <div className="project-hamburger"><span className="project-hamburger-arrow-top"></span><span className="project-hamburger-arrow-center"></span><span className="project-hamburger-arrow-bottom"></span></div>
                    <div className="project-hamburger-2"><span className="project-hamburger-arrow"></span><span className="project-hamburger-arrow"></span><span className="project-hamburger-arrow"></span>
                    </div>
                    <div className="project-close"><span></span><span></span></div>
                  </div>
                </div>
                <div className="rd-navbar-project rd-navbar-modern-project">
                  <div className="rd-navbar-project-modern-header">
                    <h4 className="rd-navbar-project-modern-title">Get in Touch</h4>
                    <div className="rd-navbar-project-hamburger" data-multitoggle=".rd-navbar-main" data-multitoggle-blur=".rd-navbar-wrap" data-multitoggle-isolate>
                      <div className="project-close"><span></span><span></span></div>
                    </div>
                  </div>
                  <div className="rd-navbar-project-content rd-navbar-modern-project-content">
                    <div>
                      <p>We are always ready to equip your business with cutting-edge security and smart retail solutions. Contact us today to see how Sensetech Trading LLC can support your growth.</p>
                      <div className="heading-6 subtitle">Our Contacts</div>
                      <div className="row row-10 gutters-10">
                        <div className="col-12"><img src={Logo} alt="" width="394" height="255"/>
                        </div>
                        {/* "assets/images/home-sidebar-394x255.jpg" */}
                      </div>
                      <ul className="rd-navbar-modern-contacts">
                        <li>
                          <div className="unit unit-spacing-sm">
                            <div className="unit-left"><span className="icon fa fa-phone"></span></div>
                            <div className="unit-body"><a className="link-phone" style={{textDecoration:"none"}} href="tel:#">+00971 503370498</a></div>
                          </div>
                        </li>
                        <li>
                          <div className="unit unit-spacing-sm">
                            <div className="unit-left"><span className="icon fa fa-location-arrow"></span></div>
                            <div className="unit-body"><a className="link-location" style={{textDecoration:"none"}} href="#">BENA COMPLEX - C, Plot Number 69-0, Oud Metha, 319-260, Dubai, UAE</a></div>
                          </div>
                        </li>
                        <li>
                          <div className="unit unit-spacing-sm">
                            <div className="unit-left"><span className="icon fa fa-envelope"></span></div>
                            <div className="unit-body"><a className="link-email" style={{textDecoration:"none"}} href="mailto:#">sales@sensetechme.com</a></div>
                          </div>
                        </li>
                      </ul>
                      <ul className="list-inline rd-navbar-modern-list-social">
                        <li><a className="icon fa fa-facebook" href="https://www.facebook.com/people/Zartec-Solutions/100069219211523/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"></a></li>
                        <li><a className="icon fa fa-x-twitter" href="https://x.com/zartecsolutions?s=11&t=VSshKmyO480f7_9yzf2lpg" target="_blank" rel="noopener noreferrer" aria-label="Twitter"></a></li>
                        {/* <li><a className="icon fa fa-google-plus" href="#"></a></li> */}
                        <li><a className="icon fa fa-instagram" href="https://www.instagram.com/zartecsolutions/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"></a></li>
                        <li><a className="icon fa fa-linkedin" href="https://www.linkedin.com/company/74349517/admin/dashboard/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
      
      </div>
  );
}

export default Header;